import React from "react";
import Logo from  '../assets/img/logo-mark.svg';

export const AuthLayout = (props) => {
  return (
      <div>
          <nav className="navbar navbar-expand-lg navbar-light bg-light shadow" style={{height:'70px'}}>
              <div className="container">
                 <img src={Logo} alt="om logo" className=""/><p className="lead fw-bold mobile-header-nav">Corporate Pensions Portal</p>
              </div>
          </nav>
          <section style={{paddingTop:'8%'}}>
              {props.children}
          </section>
      </div>
  )
}